import $ from 'jquery';
import debounce from 'lodash/debounce';

 /** Archive Search Interface */

$(document).ready(function () {
	 
	if($('.archive-pages .filters-tags-list').text().length === 0) {
      $('.archive-pages .filters-clear').hide();
    }

    var ArchiveSearch = new function () {
      var self = this

      /**
       * Object to hold current state of search page filters values
       * key - filter name
       * val - filter value (string|array)
       * @type {Object}
       */
      self.filterState = {}
      self.filterMap = {}

      // DOM element to display results in
      self.resultsContainer = {}
    self.noResultsNotice = {}
    self.loadingNotice = {}
    self.loadMoreBtn = {}
    self.paginationBtn = {}
    self.loadMoreBtnClicked
    self.isLoading = false
    self.hasLoaded = false

    // Ensure we only auto-switch on the very first load for Events
    self.initialAutoSwitchDone = false

    // Track the current in-flight request and guard against race conditions
    self.currentRequest = null
    self.requestId = 0

      const archiveVar = (typeof window !== 'undefined' && window.archive_var) ? window.archive_var : {}
      const translationStrings = archiveVar.translationStrings || {}
      const severalLocationsText = translationStrings.severalLocations || 'Several locations'
      let pathName = archiveVar.pathName !== undefined && archiveVar.pathName !== null && archiveVar.pathName !== '' ? archiveVar.pathName : '';

      /**
       * Custom WP REST API endpoint to handle results
       * @type {String}
       */
      self.apiUrl = pathName + '/wp-json/macs/v1/press_release_search_results';

      self.init = function () {

        // Get DOM elements
        self.resultsContainer = $('.filters-content')
        self.noResultsNotice  = $('.js-no-results')
        self.loadMoreBtn      = $('.filters-more')
        self.paginationContainer = $('.filters-pagination')
        self.paginationBtn    = $('.filters-pagination-btn')

        // Prevent empty-state flash before first request resolves.
        self.noResultsNotice.hide()

        self.postType = self.resultsContainer.attr('data-type')

        // Return if no required DOM or API
        if (
            !self.resultsContainer.length ||
            !self.noResultsNotice.length ||
            (self.postType !== 'employee-testimonial' && !self.loadMoreBtn.length)
        ) {
          return
        }

        self.enableActivateButtons();

        self.setApiUrl()

        // Listen to filters changes in DOM
        // Every filter change will update the window.location hash
        self.bindFiltersChange()

        // initial state: fetch data based on params in window.location.hash
        self.loadInitialState()

        // Listen to window.location.hash changes
        // Every change will refresh search results
        window.onhashchange = function() { self.refreshResults() }

        // Additional DOM behaviour tweaks
        self.loadMoreBtn.off().on('click', function(e) {
          e.preventDefault()
        })
        self.paginationBtn.off().on('click', function(e) {
          e.preventDefault()
        })

        // Make sure to hide select2 dropdowns so they don't interfere with other js events
        $( window ).on('scroll', function() {
          $('.js-with-select2').select2('close')
        })
      }

      /**
       * Enable activate buttons.
       */
      self.enableActivateButtons = function() {

        // For now the tabs are available for events only.
        if ( 'event' === self.postType ) {

          let searchParams = new URLSearchParams( window.location.search ); // phpcs:ignore WordPressVIPMinimum.JS.Window.location

          if ( searchParams.has( 'events' ) ) {

            let selectedEvents = searchParams.get( 'events' );

            if ( '' !== selectedEvents ) {

              self.enableTabButton( selectedEvents, 'disable-button' );
            }
          }

          if ( searchParams.has( 'events_type' ) ) {

            let eventTypes = searchParams.get( 'events_type' );

            let selectedEventTypes = eventTypes.split( '-' );

            if ( selectedEventTypes.length ) {

              for ( let i = 0; i < selectedEventTypes.length; i++ ) {

                self.enableTabButton( selectedEventTypes[i], 'selected-event-type' );
              }
            }
          }
        }
      }

      self.enableTabButton = function( selectedEvents, cssClass ) {

        let selectedElement = $( 'a[data-value="' + selectedEvents + '"]' );

        if ( selectedElement.length > 0 ) {

          selectedElement.addClass( cssClass );
        }
      }

      self.setApiUrl = function() {
        if ( ! self.postType ) {
          self.apiUrl = ''
        }

        self.apiUrl = pathName + '/wp-json/macs/v1/' + self.postType + '_search_results'

      }

      /**
       * Binds JS 'change' events to inputs
       * Every time the input is changed, this object's 'filterState' field
       * gets updated too and the browser's location hash is refreshed.
       */
      self.bindFiltersChange = function() {

        /**
         * bind all DOM inputs with js-filter class.
         * HTML "name" attribute will be used as filter name.
         */

        self.resultsContainer = $('.filters-content')
        self.postType = self.resultsContainer.attr('data-type')

        if ( 'event' === self.postType ) {

          $('body').addClass('all-events');

          $('.js-event-filter').on( 'click', function( e ) {

            e.preventDefault();

            $( '.js-event-filter.disable-button' ).each( function () {

              $( this ).removeClass( 'disable-button' );
            } );

            let $this = $( this );

            $this.toggleClass( 'disable-button' );

            let val = $this.data( 'value' );

            let name = 'events';

            self.filterState[name] = val;
            self.refreshUrl();
          } );

          $( '.js-event-type-filter' ).on( 'click', function( e ) {

            e.preventDefault();

            let $this = $( this );

            $this.toggleClass( 'selected-event-type' );

            let filterData = '';

            $( '.filter-container .selected-event-type' ).each( function () {

              let val = $( this ).data( 'value' );

              if ( '' !== filterData ) {

                filterData += '-' + val;

              } else {

                filterData = val;
              }
            } );

            self.filterState['events_type'] = filterData;
            self.refreshUrl();

          } );

        } 

          $('.js-filter').on( 'change', function() {
            let val = $(this).val()
            let name = $(this).attr('name')

            if (self.postType == 'employee-testimonial' ) {
              self.resultsContainer.attr( 'data-page', 1 )
            }

            let refreshFlag = false;
          if(self.filterMap[name] === undefined) {
            refreshFlag = true;
            self.filterMap[name] = val;
          } else {
            if(Array.isArray(val) && Array.isArray(self.filterMap[name])) {
              if(val.length || self.filterMap[name].length) {
                const array2Sorted = val.slice().sort();
                const isEqualArray = self.filterMap[name].length === val.length && self.filterMap[name].slice().sort().every(function(value, index) {
                    return value === array2Sorted[index];
                });
                if(!isEqualArray) {
                  refreshFlag = true;
                  self.filterMap[name] = val;
                }
              }
            } else {
              if(self.filterMap[name] !== val) {
                refreshFlag = true;
                self.filterMap[name] = val;
              }
            }
          }

            self.filterState[name] = val;

            if(refreshFlag) {
              self.refreshUrl()
            }
          } )

        // refresh results once seearch phrase is emptied
        $('.archive_phrase_search').on('keyup', debounce( function() {
          if ( '' === $(this).val() ) {
            self.filterState['search'] = '';
            self.refreshUrl()
          }
        }, 200 ) )

        /**
         * For search input the logic is a bit different
         * beacuse it's currently a form element so we need to bind submit event
         * and get search phrase from the first text input in a form
         */
        $( '.js-search-form' ).on( 'submit', function(e) {
          e.preventDefault();
          let searchInput = $(this).find('input[type=text]').first()
          let val = searchInput.val()
          let name = searchInput.attr('name')

          self.filterState[name] = val;
          self.refreshUrl()
      })

      /* Adding new code for podcast */
      
      if ( 'podcast' === self.postType ) {
        let currentUrl = window.location.href; // phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment

        let queryString = currentUrl.substring( currentUrl.indexOf( '?' ) + 1 );

        let searchParams = new URLSearchParams( queryString );

        if ( ! searchParams.has( 'podcast_category' ) ) {
          $( '.podcast-tabs' ).each(function(i, obj) {
            if($(obj).attr('data-filter') === 'technology-labs') {
              $(obj).addClass('active');
            }
          });
          self.filterState['podcast_category'] = 'technology-labs';
          self.refreshUrl()
        } else {
          $( '.podcast-tabs' ).each(function(i, obj) {
            $(obj).removeClass('active');
            if($(obj).attr('data-filter') === searchParams.get( 'podcast_category' )) {
              $(obj).addClass('active');
            }
          });
        }
      }

      $( '.podcast-tabs' ).on( 'click', function(e) {
        e.preventDefault();
        let podcast_category = $(this).attr('data-filter')

        self.filterState['podcast_category'] = podcast_category;
        self.refreshUrl()
      } )
      
      }

      /**
       * Handles search results on page load
       */
      self.loadInitialState = function() {
        self.getFiltersFromUrl()
        self.setDOMFiltersValues()
        self.refreshResults()
      }

      /**
       * Restore filters values based on the URL
       * This is mainly used when the website is loaded with location has already populated
       * (to support deeplinking)
       */
      self.getFiltersFromUrl = function() {
        let queryString = '';
        const hash = window.location.hash.replace(/[^=#%+&\w-(?!\&)]/g, ''); //phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment
        if ( hash ) {
          queryString = hash.substring(1) // remove the '#'
        }
        else {
          queryString = window.location.search; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
        }

        if ( ! queryString ) {
          return
        }

        const urlParams = new URLSearchParams( queryString );
        const params    = urlParams.entries()

        for(const [key, value] of params) {
          self.filterState[key] = value;
        }
      }

      /**
       * Reflects current filters state in html markup
       * This is  used when the website is loaded with location has already populated
       * (to support deeplinking)
       */
      self.setDOMFiltersValues = function() {
        for (const name in self.filterState) {
          const el = $('[name="'+name+'"]');
          const val = self.filterState[name].split(',')
          el.val(val)
          el.trigger('change')
        }
      }

      /**
       * Transforms params from URL into REST API request URL
       */
      self.getRequestUrlFromHash = function() {
        if ('event' === self.postType) {
          let url = window.location.href; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
  
          // if (url.indexOf('events=upcoming') > 0) {
          //   $('.upcomingEventBtn').trigger('focus');
          // }
          if ( !window.location.search ) { // phpcs:ignore WordPressVIPMinimum.JS.Window.location
            window.history.replaceState({}, '', '?events=upcoming'); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
            // $('.upcomingEventBtn').trigger('focus');
            $('.upcomingEventBtn').trigger('click');
            return self.apiUrl + '?events=upcoming';
          }
          return self.apiUrl + window.location.search; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
        } else {
          return self.apiUrl + window.location.search; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
        }
      }

      /**
       * Sets new window location hash based on this object's filterState current value
       */
      self.refreshUrl = function() {
        let params = new URLSearchParams(self.filterState);

        if (self.postType) {
          window.history.replaceState({}, '', '?' + params); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
          self.refreshResults();
        }
      }

      self.refreshUrlForEmployeeTestimonial = function() {
          if ($('.filters-tags-list').children().length === 0 && $('.filters-content').attr('data-type') === 'employee-testimonial' ) {
              let url = window.location.href; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
              url = url.split('?');
              url = url['0'];
              window.location.href = url;
          }
      }

      self.getCountAPIUrl = function() {
        const hash = window.location.hash; //phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment
        if ( hash ) {
          let queryParams = new URLSearchParams(hash);
          window.history.replaceState({}, '?' + queryParams);
        }
        let countUrl = pathName + '/wp-json/macs/v1/' + self.postType + '_search_results_count';
        return countUrl + window.location.search; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
      }

      self.refreshResults = function( append = false) {

        let ajaxUrl = self.getRequestUrlFromHash()
        let etcountUrl = self.getCountAPIUrl();

        self.resultsContainer = $('.filters-content')
        self.postType = self.resultsContainer.attr('data-type')
        self.postsPerPage = self.resultsContainer.attr('data-ppp')
        self.authorMetaKey = self.resultsContainer.attr('data-author-meta-key')

        if (self.postType == 'event' ) {

          var subStr = ajaxUrl.match("events=(.*)");

          if (subStr != null ) {

            let href = subStr[1].replace(/\&.*/,'');

            if ( ! href ) {

              $('body').addClass('all-events');
            } else {

              $('body').addClass(href);
              $('body').removeClass('all-events');
            }

            $('.js-event-filter').on( 'click', function() {

              $('body').removeClass(href);

              $(this).addClass(href);
            } );
          }
        }


        if ( append ) {
          let currentPage = self.resultsContainer.attr( 'data-page' );
          /*
          if (self.postType == 'employee-testimonial' ) {
            ajaxUrl = ajaxUrl.includes('?') ? ajaxUrl + '&page=' + currentPage : ajaxUrl + '?page=' + currentPage ;
            //api call for fetching terms post count
            etcountUrl = etcountUrl.includes('?') ? etcountUrl + '&page=' + currentPage : etcountUrl + '?page=' + currentPage ;
            self.fetchCount( etcountUrl, append );
          }
          else {
            */
            ajaxUrl = ajaxUrl.includes('?') ? ajaxUrl + '&page=' + (parseInt(currentPage, 10) + 1) : ajaxUrl + '?page=' + (parseInt(currentPage, 10) + 1) ;
         // }
        }

        if(self.postsPerPage) {
          ajaxUrl = ajaxUrl.includes('?') ? ajaxUrl + '&ppp=' + self.postsPerPage : ajaxUrl + '?ppp=' + self.postsPerPage;
        }

        if(self.authorMetaKey) {
          ajaxUrl = ajaxUrl.includes('?') ? ajaxUrl + '&author_meta_key=' + self.authorMetaKey : ajaxUrl + '?author_meta_key=' + self.authorMetaKey;
        }

        self.fetchJobs( ajaxUrl, append );
      }

      self.fetchCount = function (ajaxurl, append) {
        $.ajax({
          type: 'GET',
          url: ajaxurl,
          success: function (response, textStatus, jqXHR) {
              if ( response.filter_counts.length ) {
                // Experience
                $.each(response.filter_counts[0].grade, function(countKey,countValue ) {
                  countKey = _.unescape(countKey);
                  var expStringUpdate = countKey+' ('+countValue+')';
                  $('select#select_et_grade option:contains("'+countKey+'")').first().text(expStringUpdate);
                  $('select#select_et_grade option:contains("'+countKey+'")').first().prop('disabled', false);
                  if (countValue == 0) {
                    $('select#select_et_grade option:contains("'+countKey+'")').first().prop('disabled', 'disabled');
                  }
                })
                // Profession
                 $.each(response.filter_counts[0].profession, function (countKey, countValue) {
                countKey = _.unescape(countKey);
                var professionStringUpdate = countKey + ' (' + countValue + ')';
                $('select#select_et_profession option:contains("' + countKey + '")').first().text(professionStringUpdate);
                $('select#select_et_profession option:contains("' + countKey + '")').first().prop('disabled', false);
                if (countValue == 0) {
                  $('select#select_et_profession option:contains("' + countKey + '")').first().prop('disabled', 'disabled');
                }
              })
              // Job Family
                $.each(response.filter_counts[0].jobfamily, function(countKey,countValue ) {
                  countKey = _.unescape(countKey);
                  var jobfamilyStringUpdate = countKey+' ('+countValue+')';
                  $('select#select_et_job_family option:contains("'+countKey+'")').first().text(jobfamilyStringUpdate);
                  $('select#select_et_job_family option:contains("'+countKey+'")').first().prop('disabled', false);
                  if (countValue == 0) {
                    $('select#select_et_job_family option:contains("'+countKey+'")').first().prop('disabled', 'disabled');
                  }
                })
                // Brand
                $.each(response.filter_counts[0].brand, function(countKey,countValue ) {
                  countKey = _.unescape(countKey);
                  var brandStringUpdate = countKey+' ('+countValue+')';
                  $('select#select_et_brand option:contains("'+countKey+'")').first().text(brandStringUpdate);
                  $('select#select_et_brand option:contains("'+countKey+'")').first().prop('disabled', false);
                  if (countValue == 0) {
                    $('select#select_et_brand option:contains("'+countKey+'")').first().prop('disabled', 'disabled');
                  }
                })
                // Country
                $.each(response.filter_counts[0].country, function(countKey,countValue ) {
                  countKey = _.unescape(countKey);
                  var brandStringUpdate = countKey+' ('+countValue+')';
                  $('select#select_et_country option:contains("'+countKey+'")').first().text(brandStringUpdate);
                  $('select#select_et_country option:contains("'+countKey+'")').first().prop('disabled', false);
                  if (countValue == 0) {
                    $('select#select_et_country option:contains("'+countKey+'")').first().prop('disabled', 'disabled');
                  }
                })
                filterManipulation();
              }
          }
        })
      }

      /**
       * Fetches data from REST API and renders results
       * @param  {[type]}  ajaxurl
       * @param  {Boolean} append  determines if new results replace existing ones or are appended
       */
      self.fetchJobs = function (ajaxurl, append = false) {

        self.isLoading = true
        self.noResultsNotice.hide()
        self.resultsContainer.addClass('loading');

        if (self.currentRequest && self.currentRequest.readyState !== 4) {
          try { self.currentRequest.abort(); } catch (e) {}
        }

        const localRequestId = ++self.requestId;

        self.currentRequest = $.ajax({
          type: 'GET',
          url: ajaxurl,
          success: function (response, textStatus, jqXHR) {
            if (localRequestId !== self.requestId) {
              return;
            }

            self.isLoading = false
            self.hasLoaded = true

            // the HTML template located in post type archive
            const itemTemplate = $('#search_result_item_template').html();

            if ( ! itemTemplate.length ) {
              return;
            }

          if (!response.results || !response.results.length) {

            // On first page load, if events=upcoming yields no results, switch to past to avoid an empty experience.
            if (self.postType === 'event' && !self.initialAutoSwitchDone) {
              const search = window.location.search || '';
              const params = new URLSearchParams(search);
              const currentEvents = params.get('events') || 'upcoming';
              if (currentEvents === 'upcoming') {
                self.initialAutoSwitchDone = true;
                $('.pastEventBtn').trigger('click');
                return;
              }
            }
            
            if (!append) {
              self.resultsContainer.empty()
              if (self.hasLoaded && !self.isLoading) {
                self.noResultsNotice.show()
              }
            }
            self.loadMoreBtn.hide()
            self.paginationContainer.hide()

            setTimeout(function () {
              self.resultsContainer.removeClass('loading');
            }, 300)

            return
          } else {
            self.paginationContainer.show()
          }

          self.noResultsNotice.hide()


          // delete all items from previous search if not explicitly set to append
          //  if ( ! append || self.postType === 'employee-testimonial' ) {
          if (!append) {
            self.resultsContainer.empty()
          }

          if (self.postType === 'training-session') {
            const groupedByMonth = {};
            const trainingButtonBindings = [];

            response.results.forEach(item => {
              const month = item.month || 'Specified';
              if (!groupedByMonth[month]) groupedByMonth[month] = [];
              groupedByMonth[month].push(item);
            });

            let finalHTML = '';

            Object.keys(groupedByMonth).forEach(month => {
              const itemsHTML = groupedByMonth[month].map(item => {
                let buttonUrl = item.button_url || '';

                if (item.button_method === 'post' && buttonUrl) {
                  trainingButtonBindings.push({
                    url: buttonUrl,
                    fields: item.button_post_fields || {}
                  });
                }

                const itemData = {
                  title: item.title || '',
                  url: item.url || '',
                  trainingprice: item.training_price || '',
                  trainingdateselement: item.training_dates_element || '',
                  trainingdatetimeelement: item.training_dates_time_element || '',
                  traininglanguage: item.training_language || '',
                  traininglocation: item.training_location || '',
                  month: item.month || '',
                  featuredimagewithanchor: item.featured_image_with_anchor || '',
                  buttonurl : buttonUrl
                };
                return itemTemplate.replace(/{{\s*([a-z]+)\s*}}/g, (match, val) => itemData[val] || '');
              }).join('');

              finalHTML += `
                        <div class="expander-box">
                          <div class="expander-title" tabindex="0" role="button" aria-expanded="false" aria-pressed="false" data-filter="#collapse-${month}">${month}</div>
                          <div class="expander-content" id="collapse-${month}">
                            <div class="row">${itemsHTML}</div>
                          </div>
                        </div>
                        `;
            });

            //let html = html(finalHTML);

            self.resultsContainer.html(finalHTML); //phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append

            trainingButtonBindings.forEach(binding => {
              const candidates = self.resultsContainer
                .find(`a[href="${binding.url}"]:not([data-cg-post-bound="1"])`);

              if (!candidates.length) {
                return;
              }

              const targetLink = candidates.first();
              targetLink.attr('data-cg-post-bound', '1');

              targetLink.on('click', function (event) {
                event.preventDefault();

                const form = document.createElement('form');
                form.method = 'post';
                form.action = binding.url;
                form.style.display = 'none';

                Object.keys(binding.fields).forEach(key => {
                  const value = binding.fields[key];
                  if (value === null || value === undefined || value === '') {
                    return;
                  }

                  const input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = key;
                  input.value = String(value);
                  form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
              });
            });

            $(document).trigger('expanders:ready');

          } else {
            for (let i = 0; i < response.results.length; i++) {
              var type = response.results[i].type;
              if (self.postType === 'analyst-report') {
                type = (response.results[i].analyst !== '' ? response.results[i].analyst : (response.results[i].industry !== '' ? response.results[i].industry : (response.results[i].service !== '' ? response.results[i].service : (response.results[i].partner !== '' ? response.results[i].partner : ''))));
              }
              if (self.postType === 'client-story') {
                type = (type.indexOf(',') !== -1) ? type.split(',')[0] : type;
              }

              var post_link = response.results[i].url;

              var featured_image = response.results[i].featured_image;

              var featured_image_with_anchor = response.results[i].featured_image_with_anchor;
              var itemData = {
                title: response.results[i].title || '',
                url: post_link || '',
                type: type || '',
                theme: response.results[i].primary_term || '',
                date: response.results[i].date || '',
                location: response.results[i].location || '',
                eventtype: response.results[i].event_type || '',
                eventtypeelement: response.results[i].event_type_element || '',
                eventlocation: (function() {
                  const eventType = response.results[i].event_type?.toLowerCase() || '';
                  const eventLocation = response.results[i].event_location || '';
                  if (eventType.includes('online')) return '';
                  else if (eventType.includes('hybrid')) return severalLocationsText;
                  else if (eventType.includes('on site') || eventType.includes('on-site')) return eventLocation;
                  return eventLocation;
                })(),
                eventblocktitle: response.results[i].event_block_title || '',
                year: (response.results[i].event_block_title) ? '' : response.results[i].year,
                month: (response.results[i].event_block_title) ? '' : response.results[i].month,
                day: (response.results[i].event_block_title) ? '' : response.results[i].day,
                datestring: response.results[i].date_string || '',
                timewithzone: response.results[i].time_with_zone || '',
                hour: response.results[i].hour || '',
                banner: response.results[i].banner || '',
                addtocalendstart: response.results[i].addtocalend_start || '',
                addtocalendend: response.results[i].addtocalend_end || '',
                addtocalendstartformatted: response.results[i].addtocalend_start_formatted || '',
                addtocalendendformatted: response.results[i].addtocalend_end_formatted || '',
                eventtimestart: response.results[i].event_time_start || '',
                eventtimeend: response.results[i].event_time_end || '',
                eventtimezone: response.results[i].event_timezone || '',
                addtocalmarkup: response.results[i].add_to_cal_markup || '',
                eventclass: response.results[i].event_class || '',
                fileurl: response.results[i].file_url || '',
                filename: response.results[i].file_name || '',
                filetype: response.results[i].file_type || '',
                filesize: response.results[i].file_size || '',
                // Research and insights
                featuredimage: featured_image || '',
                featuredimagewithanchor: featured_image_with_anchor || '',
                authorurl: response.results[i].author_url || '',
                authorimage: response.results[i].author_image_html || '',
                authorname: response.results[i].author_name || '',
                brandimg: response.results[i].brand_img || '',
                // Terms
                analyst: response.results[i].analyst || '',
                industry: response.results[i].industry || '',
                service: response.results[i].service || '',
                partner: response.results[i].partner || '',
                // Blogs
                personimage: response.results[i].person_avatar || '',
                personimageselement: response.results[i].person_avatar || '',
                personname: response.results[i].person_name || '',
                // Employee Testimonials
                grade: response.results[i].grade || '',
                profession: response.results[i].profession || '',
                jobfamily: response.results[i].jobfamily || '',
                country: response.results[i].country || '',
                brand: response.results[i].brand || '',
                testimonialtitle: response.results[i].testimonial_title || '',
                excerpt: response.results[i].excerpt || '',
                //Podcast
                podcasturl: response.results[i].podcast_url || '',
                podcastoriginalurl: response.results[i].podcast_original_url || '',
              }

              var html = itemTemplate.replace(/{{\s*([a-z]+)\s*}}/g, function(match, val) {
                return itemData[val] || ''
              })

              let $html = $(html)

              if ('event' === self.postType) {

                if (itemData['addtocalendstart'] === '' || itemData['addtocalendend'] === '') {
                  $html.find('.addeventatc').remove();
                }
              }

              if ('employee-testimonial' === self.postType) {

                let boxTags = $html.find('.box-tags');

                // Add Tags.
                self.addTags(itemData['grade'], boxTags);
                self.addTags(itemData['profession'], boxTags);
                self.addTags(itemData['jobfamily'], boxTags);
                self.addTags(itemData['country'], boxTags);
                self.addTags(itemData['brand'], boxTags);
              }

              if (!itemData['fileurl']) {
                $html.find('.link-download').remove()
              }

              if ('research-and-insight' === self.postType && !itemData['authorname']) {
                $html.find('.box-author-img').remove()
                $html.find('.box-author-name').remove()
              }

              self.resultsContainer.append($html); //phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append

              if ('employee-testimonial' === self.postType) {
                // Scroll only when using numbered pagination, not on Load More.
                var containerParent = self.resultsContainer.parent();
                var offset = containerParent.length ? containerParent.offset().top : 0;
                var employeePagination = parseInt(self.resultsContainer.attr('data-employee-pagination') || 0, 10);
                if (employeePagination === 1) {
                  $("html, body").animate({ scrollTop: offset }, 1);
                }

                //  adjustTestimonialCardHeights();
              }

              if ('podcast' === self.postType) {
                let currentUrl = window.location.href; // phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment

                let queryString = currentUrl.substring(currentUrl.indexOf('?') + 1);

                let searchParams = new URLSearchParams(queryString);

                if (searchParams.has('podcast_category') && searchParams.get('podcast_category') === 'playing-with-reality') {
                  $('.podcast-box').each(function(i, obj) {
                    $(obj).find('.box-img-wrapper').css('width', '100%');
                    $(obj).find('.box-img-wrapper').css('height', '390px');
                    $(obj).find('.box-inner').hide();
                  });
                }

                if (searchParams.has('podcast_category') && searchParams.get('podcast_category') === 'technology-labs') {
                  $("#spotify_podcast_url").show();
                  $("#apple_podcast_url").show();
                  $("#sogeti_spotify_podcast_url").hide();
                }
                if (searchParams.has('podcast_category') && searchParams.get('podcast_category') === 'sogeti-labs') {
                  $("#spotify_podcast_url").hide();
                  $("#apple_podcast_url").hide();
                  $("#sogeti_spotify_podcast_url").show();
                }
                if (searchParams.has('podcast_category') && searchParams.get('podcast_category') === 'playing-with-reality') {
                  $("#spotify_podcast_url").hide();
                  $("#apple_podcast_url").hide();
                  $("#sogeti_spotify_podcast_url").hide();
                }
              }
            }
              
          }

          setTimeout(function () {

              self.resultsContainer.removeClass('loading');

              if ( 'undefined' !== typeof addeventatc ) {

                // Refreshing add to calendar button.
                // Ref: https://www.addevent.com/add-to-calendar-button#anchor-faq
                addeventatc.refresh();

              }

            }, 300 );

            self.postType = self.resultsContainer.attr('data-type')

          // Load More button updates
          self.resultsContainer.attr('data-page', response.page)
          self.resultsContainer.attr('data-page-max', response.total_pages)
          self.updateLoadMoreBtn()

          /**
           * Not sure why this code is written, just commenting out as it is giving js error.
           */
          // Add to call update.
          //          if ( 'event' === self.postType ) {
          //            window.addeventatc.generate();
          //          }

          //change pagination for employee testimonial page
          if (self.postType === 'employee-testimonial') {
            self.buildPagination(response)
          }


          self.refreshHovers()
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (textStatus === 'abort') {
            return;
          }
          if (localRequestId === self.requestId) {
            self.isLoading = false
            self.hasLoaded = true
            self.loadMoreBtn.hide()
            if (!self.isLoading) {
              self.noResultsNotice.show()
            }
          }
        },
        complete: function () {
          if (localRequestId === self.requestId) {
            self.isLoading = false
            self.currentRequest = null;
          }
        }
      })
    }

    /**
     * Campaign archive
     *
     */

    $(document).ready(function () {
      if (!$('section.campaign-archive').length) {
        return; // Exit if not on the campaign archive page
      }
      console.log("CA: Script is running on the campaign archive page");

      var baseUrl = '/wp-json/macs/v1';

      function fetchPostTypeData(postType, filters = {}) {
        if (postType === 'event') {
          filters.include_in_campaign_archive = '1'; // Only get the events marked to be included
        }
        var queryParams = new URLSearchParams(filters).toString();
        var ajaxUrl = `${baseUrl}/${postType}_search_results/?${queryParams}`;
        console.log(`CA: Fetching data for ${postType} with URL: ${ajaxUrl}`);

        return $.ajax({
          type: 'GET',
          url: ajaxUrl
        });
      }

      function renderPosts(allResults) {
        console.log("CA: Received data for all results", allResults);
        var outputHtml = '';
        allResults.forEach(result => {
          console.log(`CA: Processing results for ${result.postType}`);

          // Apply filter only for events
          if (result.postType === 'event') {
            result.data.results = result.data.results.filter(item => item.include_in_campaign === '1');
          }

          if (result.data && result.data.results.length > 0) {
            var templateId = `search_result_item_template_${result.postType}`;
            var templateSource = $('#' + templateId).html();
            console.log(`CA: Using template for ${result.postType}:`, templateSource);
            result.data.results.forEach(item => {
              var urlTarget = item.url && !item.url.includes('capgemini.com') ? '_blank' : '_self';
              var itemData = {
                title: item.title || '',
                url: item.url || '',
                urlTarget: urlTarget,
                type: item.type || '',
                theme: item.primary_term || '',
                date: item.date || '',
                location: item.location || '',
                eventtype: item.event_type || '',
                eventblocktitle: item.event_block_title || '',
                year: item.event_block_title ? '' : item.year,
                month: item.event_block_title ? '' : item.month,
                day: item.event_block_title ? '' : item.day,
                hour: item.hour || '',
                banner: item.banner || '',
                addtocalendstart: item.addtocalend_start || '',
                addtocalendend: item.addtocalend_end || '',
                addtocalendstartformatted: item.addtocalend_start_formatted || '',
                addtocalendendformatted: item.addtocalend_end_formatted || '',
                eventtimestart: item.event_time_start || '',
                eventtimeend: item.event_time_end || '',
                eventtimezone: item.event_timezone || '',
                addtocalmarkup: item.add_to_cal_markup || '',
                eventclass: item.event_class || '',
                fileurl: item.file_url || '',
                filename: item.file_name || '',
                filetype: item.file_type || '',
                filesize: item.file_size || '',
                // Campaigns
                primarytermcmp: item.primary_term || item.type,
                themescmp: item.themes_cmp || '',
                featuredimagecmp: item.featured_image || '',
                featuredimagewithanchorcmp: item.featured_image_with_anchor || '',
                // tag
                eventtype: item.event_type || '',
                eventtypeelement: item.event_type_element || '',
                eventlocation: (function () {
                  const eventType = item.event_type?.toLowerCase() || ''; 
                  const eventLocation = item.event_location || ''; 
                  if (eventType.includes('online')) return ''; 
                  else if (eventType.includes('hybrid')) return severalLocationsText; 
                  else if (eventType.includes('on site') || eventType.includes('on-site')) return eventLocation; 
                  return eventLocation;
                })(),
                authorurlcmp: item.author_url || '',
                authorimagecmp: item.author_image_html || '',
                authornamecmp: item.author_name || '',
                brandimgcmp: item.brand_img || '',
                // RNI
                primarytermrni: item.primary_term || item.type,
                featuredimagewithanchor: item.featured_image_with_anchor || '',
                authorurl: item.author_url || '',
                authorimage: item.author_image_html || '',
                authorname: item.author_name || '',
                brandimg: item.brand_img || '',
                // podcast
                 podcasturl: response.results[i].podcast_url || '',
                 podcastoriginalurl: response.results[i].podcast_original_url || '',
              };
              var itemHtml = templateSource.replace(/{{\s*([\w]+)\s*}}/g, (match, placeholder) => itemData[placeholder] || '');
              outputHtml += itemHtml;
            });
          } else {
            console.log(`CA: No results found for ${result.postType}`);
          }
        });

        if (outputHtml === '') {
          $('.filters-content-archive').html('<p>No results found.</p>');
        } else {
          $('.filters-content-archive').html(outputHtml);
        }
      }


      function determinePostTypesToQuery(filters) {
        var selectedPostTypes = $('#select_post_type').val();
        if (selectedPostTypes && selectedPostTypes.length > 0) {
          // Return selected post types if explicitly chosen
          return selectedPostTypes;
        } else {
          // Determine post types based on taxonomy filters if no post type is explicitly selected
          var postTypes = [];
          if (filters['topic'] || filters['business-theme']) {
            postTypes.push('campaigns');
          }
          if (filters['industry'] || filters['theme'] || filters['research_and_insight_type'] || filters['topic']) {
            postTypes.push('research-and-insight');
          }
          return postTypes.length > 0 ? postTypes : ['campaigns', 'research-and-insight', 'event']; // Default to all if no taxonomy filters are active
        }
      }

      function getActiveFilters() {
        var filters = {};
        $('.archive-pages .js-filter').each(function () {
          var filterName = $(this).attr('name');
          var filterValue = $(this).val();
          if (filterValue && filterValue.length > 0) {
            filters[filterName] = filterValue.join(',');
          }
        });
        var searchQuery = $('.archive-pages .archive-search-input').val();
        if (searchQuery) {
          filters.search = searchQuery;
        }

        return filters;
      }

      // Gonna be used this to track whether a fetch is currently in progress
      var isFetching = false;

      function fetchAndDisplayData() {
        if (isFetching) {
          console.log("CA: Fetch already in progress, ignoring new fetch request.");
          return;
        }

        isFetching = true; // Set the flag to true to block new fetches
        var filters = getActiveFilters();
        var postTypes = determinePostTypesToQuery(filters);
        $('.archive-pages .filters-content-archive').empty();
        var requests = postTypes.map(postType => {
          return fetchPostTypeData(postType, filters).then(data => ({
            postType: postType,
            data: data
          }));
        });

        $.when(...requests).then(function (...results) {
          renderPosts(results);
          isFetching = false; // Reset the flag when all requests are completed
        }).fail(function () {
          isFetching = false; // Ensure flag is reset even if there's an error
        });
      }


      $('.archive-pages .js-search-form').on('submit', function (event) {
        event.preventDefault();
        var searchQuery = $('.archive-search-input').val();
        var filters = { search: searchQuery };
        fetchAndDisplayData(['campaigns', 'research-and-insight', 'event'], filters);
      });

      $('.archive-pages').on('change', '#select_post_type, .js-filter', fetchAndDisplayData);

      $('.archive-pages .js-search-form').on('submit', function (event) {
        event.preventDefault();
        console.log("Search form submitted.");
        fetchAndDisplayData();
      });

      $('.archive-pages  .filters-clear').on('click', function () {
        console.log("CA: Clear all filters clicked");
        $('.archive-pages .filters-selects-list select').val([]).trigger('change');
        fetchAndDisplayData();
      });

      // Initial fetch for data on page load
      fetchAndDisplayData(['campaigns', 'research-and-insight', 'event'], {});
    });



      /**
       * Append tags to particular post.
       *
       * @param array   itemDatas List of terms.
       * @param element boxTags   HTML element where needs to add those tags.
       *
       * @return void
       */
      self.addTags = function ( itemDatas, boxTags ) {

        if ( itemDatas.length > 0 ) {

          for( let j = 0; j < itemDatas.length; j++ ) {

            $( "<span />", { text: itemDatas[j].trim() } ).appendTo( boxTags ); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.appendTo
          }
        }
      }

    self.updateLoadMoreBtn = function () {
      let currentPage = parseInt(self.resultsContainer.attr('data-page'), 10)
      let maxPages = parseInt(self.resultsContainer.attr('data-page-max'), 10)

      if (self.loadMoreBtnClicked === true) {
          let itemOfConcern = $('.archive-pages .box.filter-box').eq((parseInt(self.resultsContainer.attr('data-page'), 10) - 1) * self.postsPerPage);
          itemOfConcern.find('a').first().focus();
          self.loadMoreBtnClicked = false;
      }

      if (maxPages > currentPage) {
          self.loadMoreBtn.show()
          self.loadMoreBtn.parent().show()

          // refresh click binding
          self.loadMoreBtn.off().on( 'click', function(e) {
            e.preventDefault()
          self.refreshResults(true) // append results from next page
          self.loadMoreBtnClicked = true;
        })
        } else {
          self.loadMoreBtn.hide()
        }
      }

      self.buildPagination = function(response) {
        let currentPage = parseInt(self.resultsContainer.attr( 'data-page' ), 10 )
        let maxPages    = parseInt( self.resultsContainer.attr( 'data-page-max' ), 10 )

        let paginationHtml = '<div class="slider-nav">';
        let prevClass = 'inactive';
        let nextClass = '';
        let nextPageNo = ( parseInt(currentPage) + 1 );
        let prevPageNo = ( parseInt(currentPage) - 1 );

        if (currentPage > 1) {
          prevClass = 'active';
        }
        if (currentPage === maxPages) {
          nextClass = 'inactive';
        }

        var pageNumberArray = [];

        if (maxPages > 9) {
          if (currentPage > 5) {
            if ((maxPages - currentPage) < 4) {
              var diff = (maxPages - currentPage);
              var frontCount = 7 - (diff + 1);
              for(let i = 1; i <= frontCount; i++) {
                pageNumberArray.push(i);
              }
              pageNumberArray.push('...');
              for(let i = (currentPage-1); i <= maxPages; i++) {
                pageNumberArray.push(i);
              }
            } else {
              for(let i = 1; i <= 3; i++) {
                pageNumberArray.push(i);
              }
              pageNumberArray.push('...');
              pageNumberArray.push(currentPage-1);
              pageNumberArray.push(currentPage);
              pageNumberArray.push(currentPage+1);
              pageNumberArray.push('...');
              pageNumberArray.push(maxPages-1);
              pageNumberArray.push(maxPages);
            }
          } else {
            if (currentPage === 5) {
              for(let i = 1; i <= 6; i++) {
                pageNumberArray.push(i);
              }
              pageNumberArray.push('...');
              pageNumberArray.push(maxPages-1);
              pageNumberArray.push(maxPages);
            } else {
              for(let i = 1; i <= 5; i++) {
                pageNumberArray.push(i);
              }
              pageNumberArray.push('...');
              pageNumberArray.push(maxPages-2);
              pageNumberArray.push(maxPages-1);
              pageNumberArray.push(maxPages);
            }
          }
        } else {
          for (let i = 1; i <= maxPages; i++) {
            pageNumberArray.push(i);
          }
        }

        if ( pageNumberArray.length > 1 ) {

          //Note: @todo Inform team to migrate this to template string.
          //  paginationHtml += '<button class="filters-pagination-btn slider-prev ' + prevClass + '" data-pageNo="' + prevPageNo + '"><span class="sr-only">pagination previous</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found


          if(prevClass === 'inactive') {

            paginationHtml += '<button tabindex="-1" class="filters-pagination-btn slider-prev ' + prevClass + '" data-pageNo="' + prevPageNo + '"><span class="sr-only">pagination previous</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found
          } else {
            paginationHtml += '<button tabindex="0" class="filters-pagination-btn slider-prev ' + prevClass + '" data-pageNo="' + prevPageNo + '"><span class="sr-only">pagination previous</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found
          }

          paginationHtml += '<ul class="slider-paginator">';

          for ( let i = 0; i < pageNumberArray.length; i ++ ) {

            let pageActive = '';

            let pageNumberHtml = '<a class="filters-pagination-btn" href="javascript:void(0)" aria-label="Page '+ pageNumberArray[i] +'" data-pageNo="' + pageNumberArray[i] + '">' + pageNumberArray[i] + '</a>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found

            if ( pageNumberArray[i] === '...' ) {
              pageNumberHtml = pageNumberArray[i];
            }

            if ( currentPage === pageNumberArray[i] ) {
              pageActive = 'active';
              pageNumberHtml = pageNumberArray[i];
            }

            // NOTE: Ignoring this as it is previous added code, so I don't want to conflicts at the moment.
            paginationHtml += '<li class="paginate-item ' + pageActive + '">' + pageNumberHtml + '</li>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found
          }

          paginationHtml += '</ul>';
          //Note: @todo inform team to migrated this to template string, ignoring this for now.
          //  paginationHtml += '<button class="filters-pagination-btn slider-next ' + nextClass + '" data-pageNo="' + nextPageNo + '"><span class="sr-only">pagination next</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found

          if(nextClass === 'inactive') {

            paginationHtml += '<button tabindex="-1" class="filters-pagination-btn slider-next ' + nextClass + '" data-pageNo="' + nextPageNo + '"><span class="sr-only">pagination next</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found
          } else {
            paginationHtml += '<button tabindex="0" class="filters-pagination-btn slider-next ' + nextClass + '" data-pageNo="' + nextPageNo + '"><span class="sr-only">pagination next</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found
          }

          paginationHtml += '</div>';
        }

        self.paginationContainer.html( paginationHtml ); //phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.html

        self.paginationBtn = $('.filters-pagination-btn')

        self.paginationBtn.off().on( 'click', function(e) {
          e.preventDefault()
          self.resultsContainer.attr( 'data-page', $(this).attr('data-pageNo'))
          self.resultsContainer.attr( 'data-employee-pagination', 1 )
          self.refreshResults( true )
        } )

      }

      self.refreshHovers = function() {
        $('a.box-title, a.box-title2, .more, .more2, .more4').hover(function(){
          $(this).parents('.box').find('a.box-title, a.box-title2, .more, .more2, .more4').addClass('hover')
        }, function(){
          $(this).parents('.box').find('a.box-title, a.box-title2, .more, .more2, .more4').removeClass('hover')
        })
      }
    }()

    ArchiveSearch.init();

  function getQueryParam(param) {
    let urlParams = new URLSearchParams(window.location.search); // phpcs:ignore
    return urlParams.get(param);
  }

  // Get the date-from and date-to parameters from the URL
  let dateFrom = getQueryParam('date-from');
  let dateTo = getQueryParam('date-to');


  // --- Form ---

  function filterManipulation() {
    $('.archive-pages select, .section--searchPage select').each(function(){
      var myPlaceholder = $(this).attr('placeholder'),
          myParent = $(this).parent()

      if ($(this).attr('multiple') == 'multiple') {
        $(this).select2({
          placeholder: myPlaceholder,
          dropdownParent: myParent,
          closeOnSelect: true
        })

        let $selection = myParent.find('.select2-selection')
        //$placeholder = $( '<div>', { 'text' : myPlaceholder } )
        let $placeholder = $(`<div class="filters-option-dropdown">${myPlaceholder} </div>`)
        //  $placeholder = $(`<input type="text" readonly aria-label="${myPlaceholder} select dropdown" class="filters-multiselect-dropdown" value= ${myPlaceholder} style="min-width: 100px !important; background: transparent; border-bottom: none !important;"/>`);
        $placeholder.prependTo($selection)

        if ($(this).find('option').length < 10) {
          myParent.find('.select2-selection__rendered').hide()
        } else {
          myParent.addClass('hasSearch')
        }

        $('select').on('select2:open', function (e) {
          myParent.find('.select2-search__field').focus()
        })
        $(this).on('select2:open', function (e) {
          setTimeout(function() {
            $('.select2-results__option').each(function(){
              if($(this).attr('aria-selected') == 'true'){
                $(this).attr("aria-label",$(this).text()+" selected")
              }else{
                $(this).attr("aria-label",$(this).text())
              }
            });
          }, 100);
          //added for employee testimonial page's brand filter to remove scroll - starts
          var post_type = $('.filters-content').attr('data-type');
          if ( post_type === 'employee-testimonial' ) {
            if ( $('ul#select2-select_et_brand-results').length ) {
            //  $('ul#select2-select_et_brand-results').addClass('no-scroll-et-brand');
            }
          }
          //added for employee testimonial page's brand filter to remove scroll - ends
        });

        $('select').on('change', function (e) {
          myParent.find('.select2-search__field').focus().attr('placeholder', myPlaceholder);
          setTimeout(function() {
            $('.select2-results__option').each(function(){
              if($(this).attr('aria-selected') == 'true'){
                $(this).attr("aria-label",$(this).text()+" selected")
              }else{
                $(this).attr("aria-label",$(this).text())
              }
            });
          }, 100);
        })

        $( this ).on('select2:close', function (e) {

          e.preventDefault();

          myParent.find( '.filters-multiselect-dropdown' ).focus();
        })
        $( this ).ready(function() {
          $('.select2-search__field').hide()
        });

      } else {
        var mySearch = 10
        if ($(this).find('option').length < 10) {
          mySearch = -1
        }

        $(this).select2({
          placeholder: myPlaceholder,
          dropdownParent: myParent,
          minimumResultsForSearch: mySearch,
          closeOnSelect: true
        })
      }
      var selectLabel= myParent.find('.select2-search__field');
      //  selectLabel.attr("aria-label", "" + myPlaceholder + " dropdown");
      $( document ).ready(function() {
        setTimeout(function() {
          $('.select2-results__option').each(function(){
            if($(this).attr('aria-selected') == 'true'){
              $(this).attr("aria-label",$(this).text()+" selected")
            }else{
              $(this).attr("aria-label",$(this).text())
            }
          });
        }, 100);
        $('.select2-selection--multiple').attr("tabindex",0);
      });
    })
  }
  filterManipulation();

    $('.form input, .form textarea').focusout(function(){
      if ($(this).val() != ''){
        $(this).addClass('full')
      } else {
        $(this).removeClass('full')
      }
    })

    $('.form--oneliner input').not('.noeffect-input').on('keyup', function(){
      if ($(this).val() != ''){
        $(this).parents('.form--oneliner').addClass('full')
      } else {
        $(this).parents('.form--oneliner').removeClass('full')
      }
    })

    var val = [];
    $('.year-filter > option').each(function() {
      val.push($(this).text());
    });

    if ( val.length !== 0 ) {
      var min = Math.min(...val)
      var max = Math.max(...val)
    } else {
      var min = 0
      var max = 0
    }

    if ( 0 !== min ) {
      var date = '01/01/' + min;
    } else {
      // var date = $.datepicker.formatDate('dd/mm/yy', new Date());
    }

    function creatDateFilterTag(elem, dateCat) {
      if($(elem).val() !== '') {

        var filtersParent = $( elem ).parents( '.filters' );
        $( '.filter-date-tag[data-filter="' + elem.id + '"]' ).remove();

        // Add tags
        var template = '<span class="filters-tag filter-date-tag"><button class="filters-tag-remove" aria-label="close"><i class="icon-close" aria-hidden="true"></i></button> \
          <span></span></span>';
        let temp = $( template );

        let filteredButton = $( temp ).find( 'span' );

        filteredButton.text( $( elem ).val() );
        filteredButton.attr( 'data-value', $( elem ).val() );

        $( temp ).attr( 'data-filter', elem.id );

        if ( 'pr_datefrom' !== elem.id && 'pr_dateto' !== elem.id ) {
          // NOTE: Ignoring this as it is previous added code, so I don't want to conflict at the moment.
          filtersParent.find( '.filters-tags-list' ).append( $( temp ) ); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
        }
      }

      if(filtersParent.find('.filters-tag') && filtersParent.find('input[name=date-from]') && filtersParent.find('input[name=date-to]')){
          if (filtersParent.find('.filters-tag').length > 0 || filtersParent.find('input[name=date-from]').val() || filtersParent.find('input[name=date-to]').val() ){
              filtersParent.find('.filters-clear').show()
          }
      }
    }

    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    // Date from filters
	 console.log('reacthed datapicker init');
    $('#pr_datefrom').datepicker({
    showOn: "both", //Remove default open on focus
    dateFormat: 'MM d, yy',
      changeMonth: true,
    changeYear: true,
      // yearRange: min + ':' + max,
    defaultDate: dateFrom,
      showButtonPanel: true,
      closeText: 'Clear',
    onSelect: function (dateText, inst) {
      let selectedDate = $(this).datepicker('getDate');
      $(this).datepicker("option", "defaultDate", selectedDate);

      let fullDate = monthNames[$(this).datepicker('getDate').getMonth()] + ' ' + $(this).datepicker('getDate').getDate() + ', ' + $(this).datepicker('getDate').getFullYear();
        $('#pr_dateto').datepicker('option', 'minDate', dateText);
        $(this).val(fullDate);
        creatDateFilterTag(this);
        $(this).trigger('change');
      },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
      $(this).attr('disabled', true);
      setTimeout(function () {
        $('#pr_datefrom').attr('disabled', false);
      }, 100);
      },
      onClose: function (e) {        
        function isDonePressed() {
          return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
        }
      if (isDonePressed()) {
          $(this).val('').trigger('change');
          manageClearAllDisplay(this);
        }
        $(this).parent().removeClass("datefield-open");
        
      },
    beforeShow: function (input, inst) {
        $(this).parent().addClass("datefield-open");
        $('#ui-datepicker-div').insertAfter($(this).parent());
      $(this).parent().parent().css('position', 'initial');
      let defaultDate = $(this).datepicker("option", "defaultDate");
      if (defaultDate) {
        $(this).datepicker("setDate", defaultDate);
      }

    $( '#ui-datepicker-div' ).find( 'a.ui-state-default' ).attr('href', 'javascript:void(0)');  

    //Date From and Date To Filter - Prevent Opening Keyboard in mobile devices
    $('#pr_datefrom').attr('readonly','readonly');
    $('#pr_dateto').attr('readonly','readonly');

      $(document).keyup(function(e){
        //console.log('keyup');
        if(e.which === 40) {
           // console.log('keyup 40')
          $('#ui-datepicker-div').attr('tabindex','0').focus();
        }
      })
      
      const dayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
        "Sunday"];
      const monthsNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
    
      $('.ui-datepicker-header .ui-datepicker-prev, .ui-datepicker-header .ui-datepicker-next').attr('href','javascript:void(0)');
    
      $('.ui-datepicker-calendar tbody tr td').each(function( index ) {
        let dateDay = dayNames[$(this).index()];
        let dateMonth = monthsNames[$(this).attr('data-month')];
        let dateYear = $(this).attr('data-year');
        let date = $(this).find('a').html();
        let fullDate = date + '' + dateMonth + '' + dateYear + '' + dateDay;
        $(this).find('a').attr('aria-label', fullDate);
      });
    
      $('.ui-datepicker-month option').each(function() {
        $(this).attr('aria-label',monthsNames[$(this).index()]);
      })
    
      $('.ui-datepicker-header > a.ui-state-disabled').attr('tabindex','-1');

      if(localStorage.getItem('prevDateFocusItem')) {
      $('.'+ localStorage.getItem('prevDateFocusItem')).focus();
      }

      }
    });

    /**
     * Dynamically set the click / keyboard events to the datepicker input fields.
     * We have disabled the default show widget on focus using showOn: "none" for the
     * datepickers for consistent behaviour with the other filter elements.
     */

    /**
     * Set the date picker elements html Ids
     * @type {string[]}
     */
    const datePickerEleIds = ["#pr_datefrom", "#pr_dateto", "#ra_datefrom", "#ra_dateto"];

    /**
     * Get the datepicker input elements
     * @type {Array<HTMLInputElement | null>}
     */
    const datePickerNodes = datePickerEleIds.map((id) => document.querySelector(id));

    /**
     * Toggle the datepicker widget based on click or enter key
     * @param datePickerNode {HTMLInputElement}
     * @param e {MouseEvent | KeyboardEvent}
     */
    const toggleDatePickerWidget = (datePickerNode, e) => {
      if(e.type === 'click' || e.code === 'Enter' || e.keyCode === 13) {
        if($(datePickerNode).datepicker( "widget" ).is(":visible")){
          $(datePickerNode).datepicker('hide');
        } else {
          $(datePickerNode).datepicker('show');
        }
      }
    }

    /**
     * Loop through the datepicker elements and assign event listeners
     */
    datePickerNodes.forEach((datePickerNode) => {
      if(datePickerNode) {
        ['click', 'keydown'].forEach((eventName) => {
          datePickerNode.addEventListener(eventName, (e) => {
            toggleDatePickerWidget(datePickerNode, e);
          })
        })
      }
    });


    $('#ra_datefrom').datepicker({
      //dateFormat: 'dd MM, yy',
      dateFormat: 'dd/mm/yy',
      showOn: "none",
      changeMonth: true,
    changeYear: true,
      // yearRange: min + ':' + max,
    defaultDate: new Date(),
      showButtonPanel: true,
      closeText: 'Clear',
    onSelect: function (dateText, inst) {
        $('#ra_dateto').datepicker('option', 'minDate', dateText);
        $(this).trigger('change')
      },
      onClose: function () {
        function isDonePressed() {
          return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
        }
      if (isDonePressed()) {
          $(this).val('').trigger('change');
          manageClearAllDisplay(this);
        }
      }
    });


    // Date to filters
    $('#pr_dateto').datepicker({
    showOn: "both",
    dateFormat: 'MM d, yy',
      changeMonth: true,
    changeYear: true,
    defaultDate: dateTo,
      showButtonPanel: true,
      closeText: 'Clear',
    
    onSelect: function (dateText, inst) {
      let selectedDate = $(this).datepicker('getDate');
      let fullDate = monthNames[selectedDate.getMonth()] + ' ' + selectedDate.getDate() + ', ' + selectedDate.getFullYear();
        $(this).val(fullDate);
        creatDateFilterTag(this);

      $(this).datepicker("option", "defaultDate", selectedDate);

        $(this).trigger('change');
      },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
      $(this).attr('disabled', true);
      setTimeout(function () {
        $('#pr_dateto').attr('disabled', false);
      }, 100);
      },
      onClose: function () {
        function isDonePressed() {
          return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
        }
      if (isDonePressed()) {
          $(this).val('').trigger('change');
          manageClearAllDisplay(this);
        }
        $(this).parent().removeClass("datefield-open");
      },
    beforeShow: function (input, inst) {
      // $( this ).datepicker( "option", "showOn", "none" );
        $(this).parent().addClass("datefield-open");
        $('#ui-datepicker-div').insertAfter($(this).parent());
      $(this).parent().parent().css('position', 'initial');

      let defaultDate = $(this).datepicker("option", "defaultDate");
      if (defaultDate) {
        $(this).datepicker("setDate", defaultDate);
      }

      $( '#ui-datepicker-div' ).find( 'a.ui-state-default' ).attr('href', 'javascript:void(0)');  

    //Date From and Date To Filter - Prevent Opening Keyboard in mobile devices
    $('#pr_datefrom').attr('readonly','readonly');
    $('#pr_dateto').attr('readonly','readonly');

      $(document).keyup(function(e){
        //console.log('keyup');
        if(e.which === 40) {
           // console.log('keyup 40')
          $('#ui-datepicker-div').attr('tabindex','0').focus();
      }
    })
      
      const dayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
        "Sunday"];
      const monthsNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
    
      $('.ui-datepicker-header .ui-datepicker-prev, .ui-datepicker-header .ui-datepicker-next').attr('href','javascript:void(0)');
    
      $('.ui-datepicker-calendar tbody tr td').each(function( index ) {
        let dateDay = dayNames[$(this).index()];
        let dateMonth = monthsNames[$(this).attr('data-month')];
        let dateYear = $(this).attr('data-year');
        let date = $(this).find('a').html();
        let fullDate = date + '' + dateMonth + '' + dateYear + '' + dateDay;
        $(this).find('a').attr('aria-label', fullDate);
      });
    
      $('.ui-datepicker-month option').each(function() {
        $(this).attr('aria-label',monthsNames[$(this).index()]);
      })
    
      $('.ui-datepicker-header > a.ui-state-disabled').attr('tabindex','-1');

      if(localStorage.getItem('prevDateFocusItem')) {
      $('.'+ localStorage.getItem('prevDateFocusItem')).focus();
      }



    }
  });


    $('#ra_dateto').datepicker({
      //dateFormat: 'dd MM, yy',
      dateFormat: 'dd/mm/yy',
      showOn: "none",
      changeMonth: true,
    changeYear: true,
      // yearRange: min + ':' + max,
    defaultDate: new Date(),
      showButtonPanel: true,
      closeText: 'Clear',
      onClose: function () {
        function isDonePressed() {
          return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
        }
      if (isDonePressed()) {
          $(this).val('').trigger('change');
          manageClearAllDisplay(this);
        }
      }
    })

    // Year filter values in date from / date to

  $('.year-filter').on('change', function () {

  //    // Clear date from / ddate to filters
  //    $('#pr_datefrom').val('')
  //    $('#pr_datefrom').trigger('change')
  //    $('#ra_datefrom').val('')
  //    $('#ra_datefrom').trigger('change')
  //    $('#pr_dateto').val('')
  //    $('#pr_dateto').trigger('change')
  //    $('#ra_dateto').val('')
  //    $('#ra_dateto').trigger('change')

      let allYearOptions = $(this).val()

      if ( 0 === allYearOptions.length ) {

        allYearOptions = [];

        $( this ).find( 'option' ).each( function () {
          allYearOptions.push( $( this ).val() );
        } );
      }

      let min = Math.min(...allYearOptions);
      let max = Math.max(...allYearOptions);

      let date = $.datepicker.formatDate('mm/dd/yy', new Date());

      if ( 0 !== min ) {
        date = '01/01/' + min;
      }

      // Date from filters
      $('#pr_datefrom').datepicker('destroy')
      $('#ra_datefrom').datepicker('destroy')

      $('#pr_datefrom').datepicker({
      showOn: "none", //Remove default open on focus
      dateFormat: 'MM d, yy',
        changeMonth: true,
      changeYear: true,
      // yearRange: min + ':' + max,
      defaultDate: dateFrom,
        showButtonPanel: true,
        closeText: 'Clear',
      onSelect: function (dateText, inst) {
        let selectedDate = $(this).datepicker('getDate');
        $(this).datepicker("option", "defaultDate", selectedDate);

        let fullDate = monthNames[$(this).datepicker('getDate').getMonth()] + ' ' + $(this).datepicker('getDate').getDate() + ', ' + $(this).datepicker('getDate').getFullYear();
          $('#pr_dateto').datepicker('option', 'minDate', dateText);
          $(this).val(fullDate);
          creatDateFilterTag(this);
          $(this).trigger('change');
        },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled', true);
        setTimeout(function () {
          $('#pr_datefrom').attr('disabled', false);
        }, 100);
      },
      onClose: function (e) {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        $(this).parent().removeClass("datefield-open");

        },
      beforeShow: function (input, inst) {
          $(this).parent().addClass("datefield-open");
          $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position', 'initial');
        let defaultDate = $(this).datepicker("option", "defaultDate");
        if (defaultDate) {
          $(this).datepicker("setDate", defaultDate);
        }
        }
    });

      $('#ra_datefrom').datepicker({
        //dateFormat: 'dd MM, yy',
        showOn: "none",
        changeMonth: true,
      changeYear: true,
        yearRange: min + ':' + max,
      defaultDate: new Date(),
        showButtonPanel: true,
        closeText: 'Clear',
      onSelect: function (dateText, inst) {
          $('#ra_dateto').datepicker('option', 'minDate', dateText);
          $(this).trigger('change')
        },
        onClose: function () {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        }
      })

      // Date to filters
      $('#pr_dateto').datepicker('destroy')
      $('#ra_dateto').datepicker('destroy')

      $('#pr_dateto').datepicker({
        showOn: "none",
      dateFormat: 'MM d, yy',
        changeMonth: true,
      changeYear: true,
      defaultDate: dateTo,
        showButtonPanel: true,
        closeText: 'Clear',
      onSelect: function (dateText, inst) {
        let selectedDate = $(this).datepicker('getDate');
        let fullDate = monthNames[selectedDate.getMonth()] + ' ' + selectedDate.getDate() + ', ' + selectedDate.getFullYear();
          $(this).val(fullDate);
          creatDateFilterTag(this);

        $(this).datepicker("option", "defaultDate", selectedDate);

          $(this).trigger('change');
        },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled', true);
        setTimeout(function () {
          $('#pr_dateto').attr('disabled', false);
        }, 100);
        },
        onClose: function () {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        $(this).parent().removeClass("datefield-open");
        },
      beforeShow: function (input, inst) {
          $(this).parent().addClass("datefield-open");
          $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position', 'initial');

        let defaultDate = $(this).datepicker("option", "defaultDate");
        if (defaultDate) {
          $(this).datepicker("setDate", defaultDate);
        }
        }
    });

      $('#ra_dateto').datepicker({
        //dateFormat: 'dd MM, yy',
        showOn: "none",
        changeMonth: true,
      changeYear: true,
        yearRange: min + ':' + max,
      defaultDate: new Date(),
        showButtonPanel: true,
        closeText: 'Clear',
        onClose: function () {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        }
      })
    })


    //cleardates


    $('#clearDates').on('click', function () {


      $('#pr_datefrom').datepicker('destroy');
      $('#ra_datefrom').datepicker('destroy');


      $('#pr_dateto').datepicker('destroy');
      $('#ra_dateto').datepicker('destroy');

      var val = [];
      $('.year-filter > option').each(function() {
        val.push($(this).text());
      });

      if ( val.length !== 0 ) {
        var min = Math.min(...val)
        var max = Math.max(...val)
      } else {
        var min = 0
        var max = 0
      }

      if ( 0 !== min ) {
        var date = '01/01/' + min;
      } else {
        var date = $.datepicker.formatDate('mm/dd/yy', new Date())
      }

  // Date from filters
      $('#pr_datefrom').datepicker({
      showOn: "none", //Remove default open on focus
      dateFormat: 'MM d, yy',
        changeMonth: true,
      changeYear: true,
      // yearRange: min + ':' + max,
      defaultDate: dateFrom,
        showButtonPanel: true,
        closeText: 'Clear',
      onSelect: function (dateText, inst) {
        let selectedDate = $(this).datepicker('getDate');
        $(this).datepicker("option", "defaultDate", selectedDate);

        let fullDate = monthNames[$(this).datepicker('getDate').getMonth()] + ' ' + $(this).datepicker('getDate').getDate() + ', ' + $(this).datepicker('getDate').getFullYear();
          $('#pr_dateto').datepicker('option', 'minDate', dateText);
          $(this).val(fullDate);
          creatDateFilterTag(this);
          $(this).trigger('change');
        },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled', true);
        setTimeout(function () {
          $('#pr_datefrom').attr('disabled', false);
        }, 100);
      },
      onClose: function (e) {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        $(this).parent().removeClass("datefield-open");

        },
      beforeShow: function (input, inst) {
          $(this).parent().addClass("datefield-open");
          $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position', 'initial');
        let defaultDate = $(this).datepicker("option", "defaultDate");
        if (defaultDate) {
          $(this).datepicker("setDate", defaultDate);
        }
      }
    });

      $('#ra_datefrom').datepicker({
        //dateFormat: 'dd MM, yy',
        showOn: "none",
        changeMonth: true,
      changeYear: true,
        yearRange: min + ':' + max,
      defaultDate: new Date(),
        showButtonPanel: true,
        closeText: 'Clear',
      onSelect: function (dateText, inst) {
          $('#ra_dateto').datepicker('option', 'minDate', dateText);
          $(this).trigger('change')
        },
        onClose: function () {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        }
      })

      // Date to filters
      $('#pr_dateto').datepicker({
        showOn: "none",
      dateFormat: 'MM d, yy',
        changeMonth: true,
      changeYear: true,
      defaultDate: dateTo,
        showButtonPanel: true,
        closeText: 'Clear',
      onSelect: function (dateText, inst) {
        let selectedDate = $(this).datepicker('getDate');
        let fullDate = monthNames[selectedDate.getMonth()] + ' ' + selectedDate.getDate() + ', ' + selectedDate.getFullYear();
          $(this).val(fullDate);
          creatDateFilterTag(this);

        $(this).datepicker("option", "defaultDate", selectedDate);

          $(this).trigger('change');
        },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled', true);
        setTimeout(function () {
          $('#pr_dateto').attr('disabled', false);
        }, 100);
        },
        onClose: function () {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        $(this).parent().removeClass("datefield-open");
        },
      beforeShow: function (input, inst) {
          $(this).parent().addClass("datefield-open");
          $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position', 'initial');

        let defaultDate = $(this).datepicker("option", "defaultDate");
        if (defaultDate) {
          $(this).datepicker("setDate", defaultDate);
        }
      }
    });

      $('#ra_dateto').datepicker({
        //dateFormat: 'dd MM, yy',
        showOn: "none",
        changeMonth: true,
      changeYear: true,
        yearRange: min + ':' + max,
      defaultDate: new Date(),
        showButtonPanel: true,
        closeText: 'Clear',
        onClose: function () {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        }
      })

    })


    //tagscleardates


    $('.filters-tags-list').on('click', function () {


      $('#pr_datefrom').datepicker('destroy');
      $('#ra_datefrom').datepicker('destroy');


      $('#pr_dateto').datepicker('destroy');
      $('#ra_dateto').datepicker('destroy');

      var val = [];
      $('.year-filter > option').each(function() {
        val.push($(this).text());
      });

      if ( val.length !== 0 ) {
        var min = Math.min(...val)
        var max = Math.max(...val)
      } else {
        var min = 0
        var max = 0
      }

      if ( 0 !== min ) {
        var date = '01/01/' + min;
      } else {
        var date = $.datepicker.formatDate('mm/dd/yy', new Date())
      }


  // Date from filters
      $('#pr_datefrom').datepicker({
      showOn: "none", //Remove default open on focus
      dateFormat: 'MM d, yy',
        changeMonth: true,
      changeYear: true,
      // yearRange: min + ':' + max,
      defaultDate: dateFrom,
        showButtonPanel: true,
        closeText: 'Clear',
      onSelect: function (dateText, inst) {
        let selectedDate = $(this).datepicker('getDate');
        $(this).datepicker("option", "defaultDate", selectedDate);

        let fullDate = monthNames[$(this).datepicker('getDate').getMonth()] + ' ' + $(this).datepicker('getDate').getDate() + ', ' + $(this).datepicker('getDate').getFullYear();
          $('#pr_dateto').datepicker('option', 'minDate', dateText);
          $(this).val(fullDate);
          creatDateFilterTag(this);
          $(this).trigger('change');
        },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled', true);
        setTimeout(function () {
          $('#pr_datefrom').attr('disabled', false);
        }, 100);
      },
      onClose: function (e) {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        $(this).parent().removeClass("datefield-open");

        },
      beforeShow: function (input, inst) {
          $(this).parent().addClass("datefield-open");
          $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position', 'initial');
        let defaultDate = $(this).datepicker("option", "defaultDate");
        if (defaultDate) {
          $(this).datepicker("setDate", defaultDate);
        }
        }
    });

      $('#ra_datefrom').datepicker({
        //dateFormat: 'dd MM, yy',
        showOn: "none",
        changeMonth: true,
      changeYear: true,
        yearRange: min + ':' + max,
      defaultDate: new Date(),
        showButtonPanel: true,
        closeText: 'Clear',
      onSelect: function (dateText, inst) {
          $('#ra_dateto').datepicker('option', 'minDate', dateText);
          $(this).trigger('change')
        },
        onClose: function () {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        }
      })

      // Date to filters
      $('#pr_dateto').datepicker({
        showOn: "none",
      dateFormat: 'MM d, yy',
        changeMonth: true,
      changeYear: true,
      defaultDate: dateTo,
        showButtonPanel: true,
        closeText: 'Clear',
      onSelect: function (dateText, inst) {
        let selectedDate = $(this).datepicker('getDate');
        let fullDate = monthNames[selectedDate.getMonth()] + ' ' + selectedDate.getDate() + ', ' + selectedDate.getFullYear();
          $(this).val(fullDate);
          creatDateFilterTag(this);

        $(this).datepicker("option", "defaultDate", selectedDate);

          $(this).trigger('change');
        },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled', true);
        setTimeout(function () {
          $('#pr_dateto').attr('disabled', false);
        }, 100);
        },
        onClose: function () {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        $(this).parent().removeClass("datefield-open");
        },
      beforeShow: function (input, inst) {
          $(this).parent().addClass("datefield-open");
          $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position', 'initial');

        let defaultDate = $(this).datepicker("option", "defaultDate");
        if (defaultDate) {
          $(this).datepicker("setDate", defaultDate);
        }
        }
    });

      $('#ra_dateto').datepicker({
        //dateFormat: 'dd MM, yy',
        showOn: "none",
        changeMonth: true,
      changeYear: true,
        yearRange: min + ':' + max,
      defaultDate: new Date(),
        showButtonPanel: true,
        closeText: 'Clear',
        onClose: function () {
          function isDonePressed() {
            return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
          }
        if (isDonePressed()) {
            $(this).val('').trigger('change');
            manageClearAllDisplay(this);
          }
        }
      })

    })

    var filter = $('.filters-content')
    var postType = filter.attr('data-type')

    if (postType == 'event' ) {

      if (window.ifaddtocalendar === undefined) {
        window.ifaddtocalendar = 1
        var d = document; var s = d.createElement('script'); var g = 'getElementsByTagName'; var h = d[g]('body')[0]
        s.type = 'text/javascript'; s.charset = 'UTF-8'; s.async = true
        s.src = (window.location.protocol === 'https:' ? 'https' : 'http') + '://addevent.com/libs/atc/1.6.1/atc.min.js' // phpcs:ignore WordPressVIPMinimum.JS.Window.location
        h.appendChild(s)
      }
    }

    function manageClearAllDisplay(d) {
      if ($(d).parents('.filters').find('.filters-tag').length == 0) {
        if ($(d).parents('.filters').find('input[name=date-from]').val() == undefined) {
          $(d).parents('.filters').find('.filters-clear').hide()
        }
        if ($(d).parents('.filters').find('input[name=date-from]').val() == '' && $(d).parents('.filters').find('input[name=date-to]').val() == '') {
          $(d).parents('.filters').find('.filters-clear').hide()
        }
      }
    }


  })

  